module.exports = __webpack_public_path__ + "img/win-trade.2cc12b1e.png";